'use client';

import type { FC } from 'react';
import withScroll from '@/components/hoc/withScroll';
import Logo from '@/components/icons/Logo';
import NavActions from '@/components/navigation/NavActions/NavActions.client';
import NavList from '@/components/navigation/NavList';

const Navigation: FC = () => {
  return (
    <div className='relative mx-auto max-w-[90rem] px-6 sm:px-6 lg:px-8'>
      <nav aria-label='Main navigation' className='flex items-center justify-between py-6'>
        <div className='flex items-center'>
          <Logo height={32} />
        </div>
        <div className='hidden flex-1 items-center justify-center lg:flex'>
          <NavList className='gap-x-10' />
        </div>
        <div className='flex items-center'>
          <NavActions />
        </div>
      </nav>
    </div>
  );
};

Navigation.displayName = 'Navigation';

export default withScroll(Navigation);
